module.exports = __webpack_public_path__ + "img/background013.jpg";